import {autoserialize, autoserializeAs} from 'cerialize';
import {CampaignItemModel} from './campaign-item.model';

export class UpdateAssignableCampaignItemModel {
    @autoserialize
    @autoserializeAs(CampaignItemModel) public campaignItem: CampaignItemModel;
    @autoserialize
    public active: boolean;
}
